/*
 * @Author: withease-partner+cao@hashdash-group.com
 * @Description: the frame page of 「成功的按钮：边角是圆的有背景颜色的按钮」
 */
<template>
  <div class="cNobgButton-container">
    <p
      class="buttonRound"
      :class="disabled ? 'disableds' : ''"
      @click="clickbtn"
    >
      {{ text }}
    </p>
  </div>
</template>


<script>
export default {
  props: ['text', 'disabled'],
  methods: {
    clickbtn() {
      if (!this.disabled) {
        this.$emit('clickbtn');
      }
    }
  }
};
</script>

<style lang="less"  scoped>
.cNobgButton-container {
  width: 100%;
  .buttonRound {
    width: 100%;
    height: 0.5rem;
    border: 2px solid #00a4b0;
    opacity: 1;
    border-radius: 25px;
    font-size: 0.18rem;
    font-family: Hiragino Sans;
    font-weight: bold;
    color: #00a4b0;
    text-align: center;
    line-height: 0.5rem;
    cursor: pointer;
  }
  .buttonRound.disableds {
    background: #adadad;
    color: #ffffff;
    border: none;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Button/cNoBgButton.vue